module.exports = __webpack_public_path__ + "static/media/poweredNuxiba.079c887e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Footer/poweredNuxiba.svg
// module id = 1773
// module chunks = 0